import { FC, useState } from "react";
import { Box } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import { Star as StarIcon } from "@material-ui/icons";

import { Button, FavoriteIconButton } from "components";
import { useAssetDetailData } from "containers/AssetDetail/hooks";
import { FeaturedSource, ListingState } from "services/listings/types";
import theme from "theme";

import FeatureListingModal from "./FeatureListingModal";
import ListPriceRequiredModal from "./ListPriceRequiredModal";

interface HeaderActionButtonProps {
  featuredSource: FeaturedSource | null;
  hasDeal: boolean;
  isBuyNowPriceSet: boolean;
  isFeatured: boolean;
  isInFeatureQueue: boolean;
  isOwner: boolean;
  isSecondaryListing: boolean;
  listingId: number;
  listingState: ListingState;
}

const HeaderActionButton: FC<HeaderActionButtonProps> = ({
  featuredSource,
  hasDeal,
  isBuyNowPriceSet,
  isFeatured,
  isInFeatureQueue,
  isOwner,
  isSecondaryListing,
  listingId,
  listingState,
}) => {
  const { handleRefreshListing } = useAssetDetailData(listingId);
  const [isFeatureListingModalOpen, setIsFeatureListingModalOpen] = useState(
    false,
  );

  const [
    isListPriceRequiredModalOpen,
    setIsListPriceRequiredModalOpen,
  ] = useState(false);

  const setHeaderActionModalOpen = () => {
    if (isBuyNowPriceSet) {
      setIsFeatureListingModalOpen(true);
      return;
    }
    setIsListPriceRequiredModalOpen(true);
  };

  return (
    <>
      {isOwner && isSecondaryListing && (
        <Tooltip
          title={
            hasDeal || listingState === "accepting_final_offers"
              ? "Listings with accepted offers cannot be featured."
              : isFeatured && featuredSource === "owner"
              ? "Your listing is already featured. You will receive an email when it is removed from the featured section."
              : isFeatured && featuredSource === "staff"
              ? "Your listing is already featured."
              : isInFeatureQueue
              ? "Your listing is already on the list. You will receive an email when your listing is featured."
              : ""
          }
        >
          <div style={{ height: "fit-content" }}>
            <Button
              id="btn-get-featured"
              variant="contained"
              size="large"
              type="submit"
              onClick={setHeaderActionModalOpen}
              disabled={
                hasDeal ||
                isFeatured ||
                isInFeatureQueue ||
                listingState === "accepting_final_offers"
              }
              style={{ minWidth: "171px" }}
            >
              <Box display="flex" alignItems="center">
                <StarIcon
                  style={{
                    color: theme.custom.palette.yellow.main,
                    marginRight: theme.spacing(1),
                  }}
                />
                Get Featured
              </Box>
            </Button>
          </div>
        </Tooltip>
      )}

      {!isOwner && (
        <FavoriteIconButton
          listingId={listingId}
          listingState={listingState}
          withBorder
          isAssetDetailsModal
        />
      )}

      {isFeatureListingModalOpen && (
        <FeatureListingModal
          onClose={() => setIsFeatureListingModalOpen(false)}
          listingId={listingId}
          onSuccessfulFeatureRequest={handleRefreshListing}
        />
      )}
      {isListPriceRequiredModalOpen && (
        <ListPriceRequiredModal
          onClose={() => setIsListPriceRequiredModalOpen(false)}
        />
      )}
    </>
  );
};

export default HeaderActionButton;
